import { useTwoFactorAuthenticationFactory } from "@Modules/admin/views/user/store"
import createStore from "@Stores/base-factories"

const { Provider, useStore } = createStore()
  .extendHookCollectionFactory('organization/user')
  .extendHookCollectionsFactory('organization/users')
  .extend(useTwoFactorAuthenticationFactory)
  .factory()

export {
  Provider as UserProvider,
  useStore as useUserStore,
}
